import { render, staticRenderFns } from "./LSelectController.vue?vue&type=template&id=1f855097&scoped=true"
import script from "./LSelectController.vue?vue&type=script&lang=js"
export * from "./LSelectController.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f855097",
  null
  
)

export default component.exports